<template lang="">
    <div class="myOrders">
        <div v-if="orderLengths!=0">
            <div class="orderItem" v-for="item in orderLists" :key="item.order_id">
                <div class="item-top">订单号：{{item.order_sn}}</div>
                <div class="item-center">
                    <div class="center-left">
                        <img :src="item.order_product_thumb" />
                    </div>
                    <div class="center-right">
                        <div class="right-title">{{item.order_product_name}}</div>
                        <div class="right-name">{{item.order_card_name}}</div>
                        <div class="right-product">{{item.order_time}}</div>
                    </div>
                </div>
                <div class="item-bottom">
                    <button class="button-1" @click="goDetail(item)">订单详情</button>
                    <button class="button-2" @click="qrcodeDuoKa(item)">查看物流</button>
                </div>
            </div>
        </div>
        
        <div class="noData" v-else>
            <img src="./../../assets/img/home/noOrder.png" />
            <div class="noData-tip">您还没有订单记录哦~</div>
        </div>
        <van-overlay :show="show" @click="onCloseOverlay" >
                <div class="wrapper">
                    <div class="block"  @click.stop>
                        <img :src="baseUrl" />
                        <div class="tip-content">
                            长按识别二维码 
                        </div>
                        <div class="tip-content">
                            订单状态实时更新推送
                        </div>

                    </div>
                </div>
        </van-overlay>
    </div>
</template>
<script>
import {orderList,qrcodeDuoKa} from "@/api"
export default {
    data(){
        return{
            show:false,
            orderLists:[],
            baseUrl:"",
            orderLengths:1
        }
    },
    mounted(){
        this.orderList();
    },
    methods:{
        /**
         * 关闭遮罩
         */
        onCloseOverlay(){
            this.show = false;
        },
        /**
         * 跳到详情
         */
        goDetail(item){
            console.log(item)
            this.$router.push({
                name:"OrderDetail",
                query:{order_sn:item.order_sn  }
            })
        },
        /**
         * 获取订单列表
         */
        async orderList(){
            const[err,data] = await orderList();
            if(err)  return this.orderLengths=0
            this.orderLists = data;
            this.orderLengths = this.orderLists.length;

            
            
        },
        /**
         * 获取多卡公众号
         */
        async qrcodeDuoKa(item){
            const [err,data] = await qrcodeDuoKa({
                order_sn : item.order_sn  
            });
            if(err) return console.warn(err);
            this.baseUrl = data.url;
             this.show = true;
        }
    }
}
</script>
<style lang="scss" scoped>

    .myOrders{
        padding: 19px 25px;
        background: #EFEFEF;
        min-height: 100%;
        box-sizing: border-box;
        .noData{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: absolute;
            img{
                width: 526px;
                height: 372px;
            }
            .noData-tip{
                font-size: 24px;
                color: #333;
                margin-top: 20px;
            }
        }
        .orderItem{
            width: 100%;
            background: #fff;
            margin-bottom: 16px;
            .item-top{
                padding: 0 18px;
                height: 82px;
                line-height: 82px;
                background:rgba(247,247,247,1);
                font-size:28px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(252,133,53,1);
            }
            .item-center{
                padding: 30px 18px;
                display: flex;
                .center-left{
                    margin-right: 16px;
                    img{
                        width: 144px;
                        height: 144px;
                    }
                }
                .center-right{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .right-title{
                        font-size:24px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(77,77,77,1);
                        line-height:35px;
                    }
                    .right-name{
                        font-size:22px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(125,125,125,1);
                    }
                    .right-product{
                        font-size:22px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(102,102,102,1);
                    }
                }
            }
            .item-bottom{
                padding: 18px;
                text-align: right;
                border-top:1px solid rgba(205,205,205,1);
                button{
                    width:147px;
                    height:52px;
                    border:1px solid rgba(205,205,205,1);
                    border-radius:4px 4px 4px 4px;
                    background: #fff;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(48,48,48,1);
                }
                .button-1{
                    border:1px solid rgba(252,133,53,1);
                }
                .button-2{
                    margin-left: 38px;
                    font-size:22px;

                }
            }
        }
         .wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .block {
            width:460px;
            background-color: #fff;
            padding:  49px;
            text-align: center;
            img{
                width: 360px;
                height: 360px;
                margin-bottom: 27px;
            }
            .tip-content{
                font-size:32px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(48,48,48,1);
                line-height:44px;
                margin: 0 auto;
                text-align: center;
            }
        }
    }
</style>